import { render, staticRenderFns } from "./OrderCreationResult.vue?vue&type=template&id=ebec528e&"
import script from "./OrderCreationResult.vue?vue&type=script&lang=js&"
export * from "./OrderCreationResult.vue?vue&type=script&lang=js&"
import style0 from "./OrderCreationResult.vue?vue&type=style&index=0&id=ebec528e&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports